import { render, staticRenderFns } from "./RoommateRequestDialog.vue?vue&type=template&id=56bf5b2b&"
import script from "./RoommateRequestDialog.vue?vue&type=script&lang=js&"
export * from "./RoommateRequestDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports